<template>
	<div class="coupons" :class="[{'coupon-error': error}, {'loading': loading}]">
		<div class="base-coupon" :class="[{'base-coupon-error': error}, {'loading': loading}]">
			<form class="coupons-form" @submit.prevent="couponCode && onSubmit()">
				<input :placeholder="labels.get('coupon_code')" type="text" name="coupon" v-model="couponCode" />
				<button class="btn btn-white" type="submit" :disabled="!couponCode"><BaseCmsLabel code="coupon_add" /></button>
			</form>
			<BaseCmsLabel v-if="message" class="msg" tag="div" :code="message" />
		</div>

		<div v-if="couponsList.meta_data" class="coupons-list">
			<div v-for="(item, index) in couponsList.meta_data" :key="index" class="coupons-list-item" :class="{'unactive': !item.applied}">
				<div class="title">
					"{{ item.code }}"
					<template v-if="item.applied"><BaseCmsLabel code="coupon_valid" /></template>
					<template v-else><BaseCmsLabel code="coupon_not_valid" /></template>
				</div>
				<div class="btn-remove" @click="onRemove(item.code)"><BaseCmsLabel code="coupon_remove" /></div>
			</div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const endpoints = useEndpoints();
	const webshop = useWebshop();
	const auth = useAuth();
	const {emit} = useEventBus();
	const couponCode = ref('');
	const message = ref('');
	const error = ref(0);
	const loading = ref(false);
	const cartData = computed(() => webshop.getCartData());
	const couponsList = ref(null);

	watchEffect(() => {
		if (cartData.value?.total?.extraitems) {
			couponsList.value = cartData.value.total.extraitems.find(el => el.type == 'coupon');
		}
	});

	// clear status message after 4 seconds
	let couponTimeout;
	watch(
		() => message.value,
		async () => {
			if (!message.value) return;
			couponTimeout = setTimeout(async () => {
				message.value = '';
				error.value = 0;
			}, 4000);
		}
	);

	function handleInput(event) {
		couponCode.value = event.target.value;
	}

	async function onSubmit() {
		clearTimeout(couponTimeout);
		loading.value = true;
		message.value = '';

		await useApi(
			`${endpoints.get('_post_hapi_webshop_coupon')}`,
			{
				method: 'POST',
				body: {code: [couponCode.value]},
			}
		).then(async res => {
			if(res.success) {
				await webshop.fetchCart();
				error.value = 0;
			} else {
				error.value = 1;
			}

			message.value = labels.get(res?.data?.label_name);
			couponCode.value = '';
		});

		loading.value = false;
	}

	async function onRemove(value) {
		clearTimeout(couponTimeout);
		loading.value = true;
		message.value = '';
		error.value = 0;

		await webshop.removeCoupon({code: value});
		loading.value = false;
	}

	onBeforeUnmount(() => {
		clearTimeout(couponTimeout);
	});
</script>

<style lang="less" scoped>
	.base-coupon{position: relative;}
	.coupons {
		margin-bottom: 25px;
		&.loading{pointer-events: none; opacity: 0.7;}

		@media (max-width: @m) {margin-bottom: 19px;}
	}
	.coupons-form{
		display: grid; align-items: center; position: relative;
		&:before{.icon-coupon(); font: 16px/1 @fonti; color: @blue; position: absolute; left: 20px; top: 18px;}
	}
	.msg{position: absolute; font-size: 12px; padding: 3px 0 0 20px;}
	.coupon-error{
		input{border-bottom: 2px solid @red2;}
		.msg{color: @red2;}
	}
	.coupon-success{
		input{border-bottom: 2px solid @blue;}
		.msg{color: @blue;}
	}
	.ww-coupon-delete{cursor: pointer;}
	input{
		flex-grow: 1; height: 50px; border: 1px solid @borderColor; border-right: 0; font-size: 15px; padding-right: 110px; padding-left: 50px; position: relative;	z-index: 1; background: transparent; .placeholder(@textColor, @placeholderColor);
		&[readonly]{cursor: default;}
	}
	button{
		min-width: 100px; padding: 0; position: absolute; top: 0; border-color: @blue; right: 0; z-index: 1; height: 50px; font-size: 15px; font-weight: 600; color: @blue; .transition(all);
		&:disabled{border-color: @borderColor; color: @borderColor;}
		&:not(:disabled):hover{background: @secondaryColor; color: #fff; border-color: @secondaryColor;}

		@media (max-width: @t){
			&:not(:disabled):hover{background: @white; border-color: @blue; color: @blue;}
		}
	}

	.coupons-list{margin-top: 30px; border-bottom: 1px solid @borderColor;}
	.coupons-list-item{
		display: flex; align-items: center; margin-bottom: 15px; font-size: 13px; color: @textColor; font-weight: bold;
		&.unactive .title{
			color: #7891A9;
			&:before{.icon-available-last; color: @red2; font-size: 14px;}
		}
		.title{
			flex-grow: 1; padding: 0 15px 0 25px; position: relative;
			&:before{.icon-coupon; font: 13px/1 @fonti; color: @blue; position: absolute; top: 3px; left: 0;}
		}
		.btn-remove{
			color: @blue; cursor: pointer;
			&:hover{text-decoration: underline;}
		}
	}
</style>
